import React from 'react';
import { Box, styled, Skeleton as MuiSkeleton } from '@mui/material';
import clsx from 'clsx';
import { omit } from 'lodash-es';
import { getStyle, skeletonClasses } from './style';
import { randomStr } from '../../Shared';
const defaultStyle = {
    width: {
        0: '100%',
        1: '66.5%',
        2: '33.25%',
    },
};
const SkeletonBase = React.forwardRef((props, ref) => {
    const { containerProps, className, sx, row, classes = {}, variant, ...rest } = props;
    const currentRow = row ?? (variant ? 1 : 3);
    return (React.createElement(Box, { ref: ref, width: "100%", ...containerProps, className: clsx(skeletonClasses.container, containerProps?.className) }, new Array(currentRow).fill(1).map((item, index) => (React.createElement(MuiSkeleton, { className: className, key: `${item}-${randomStr()}`, sx: sx, classes: { ...omit(skeletonClasses, 'container'), ...classes }, width: defaultStyle.width[index % 3], variant: variant, ...rest })))));
});
const StyledSkeleton = styled(SkeletonBase)((props) => {
    const { theme, size, variant } = props;
    return getStyle(theme, { size, variant });
});
//  The exposed components must support the use of ref.
const Skeleton = React.forwardRef((props, ref) => (React.createElement(StyledSkeleton, { ...props, ref: ref })));
export default Skeleton;
